<template>
  <div>
    <div>
      <a-row>
        <a-descriptions bordered size="medium">

            <a-descriptions-item :key="key" v-for="key of Object.keys(ViewData)" v-if="ViewData[key]" :label="extractLabels(key)" :span="3">
              
              {{ fieldsFormatter(key, ViewData[key]) }}
              
            </a-descriptions-item>

            <!-- <a-descriptions-item v-if="ViewData['promotion_tnc']" label="Terms and Conditions" :span="3">
              <ckeditor v-model="ViewData.promotion_tnc" disabled="true"></ckeditor>
              <div v-html="ViewData.promotion_tnc"></div>
            </a-descriptions-item>

            <a-descriptions-item v-if="ViewData['promotion_is_active']" label="Status" :span="3">{{ ViewData.promotion_is_active === 'Y' ? 'Active' : 'Inactive'  }}</a-descriptions-item> -->

        </a-descriptions>
      </a-row>

      <!-- <a-row style="margin: 20px 0;">
        <a-descriptions v-if="ViewData['promotion_image_url_1']">
          <a-descriptions-item label="Image 1">
            <img height="250" width="250" :src="IMAGE_URL+ViewData.promotion_image_url_1" shape="square" />
          </a-descriptions-item>
        </a-descriptions>
      </a-row> -->
    </div>
    <slot></slot>
  </div>
</template>

<script>
/* eslint-disable */
import { getFormattedDate } from '@/helpers/formatters';

export default {
  props: {
    viewdata: {
      type: Object,
    },
  },
  components: {},
  data() {
    return {
      IMAGE_URL: IMAGEURL,
      
    };
  },
  computed: {
    ViewData() {
      return this.viewdata;
    },
    fieldsToFormatDate() {
      return [
        'transaction_date_time',
        'movie_show_date',
        'vista_Session_dtmRealShow',
        'created_at',
        'updated_at',
        'transaction_date_timestamp'
      ];
    },
    yesNoDict() {
      return {
        Y: 'Yes', 
        N: 'No'
      }
    }
  },
  watch: {},
  beforeMount() {},
  methods: {
    extractLabels(str) {
      if(!str) {
        return null;
      }
      let words = str.split('_');
      words.forEach((word, index) => {
        words[index] = word[0].toUpperCase() + word.substring(1);
      });
      return words.join(' ');
    },
    fieldsFormatter(key, value) {
      console.log(this);
      if(this.fieldsToFormatDate.includes(key)) {
        return getFormattedDate(value);
      } else if(this.yesNoDict[value]) {
        return this.yesNoDict[value]
      } else {
        return value;
      }
    }
  },
};
</script>

<style>
</style>